import { render } from "./PolicyLayout.vue?vue&type=template&id=2a4997ba&scoped=true"
import script from "./PolicyLayout.vue?vue&type=script&lang=ts"
export * from "./PolicyLayout.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2a4997ba"

export default script